import React, {PropTypes} from 'react';

const FormMultiline = ({
	className,
  input, 
  placeholder,
  ref,
  type,
  rows,
  cols
}) => (
  <textarea {...input}
          type={type} 
          className={className} 
          placeholder={placeholder}
          ref={ref}
          rows={rows}
          cols={cols}
  />
);

FormMultiline.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  ref: PropTypes.string,
  type: PropTypes.string.isRequired,
  rows: PropTypes.string,
  cols: PropTypes.string
};

export default FormMultiline;


/** WEBPACK FOOTER **
 ** ./src/modules/common/components/FormMultiline.js
 **/